// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-chip {
  align-items: center;
  display: inline-flex;
  font-weight: 400;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-chip .v-icon {
  --v-icon-size-multiplier: 0.8571428571;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-small {
  --v-chip-size: 0.625rem;
  --v-chip-height: 20px;
  font-size: 0.625rem;
  padding: 0 8px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-avatar {
  --v-avatar-height: 14px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-small .v-avatar {
  --v-avatar-height: 20px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-avatar--start {
  margin-inline-start: -5.6px;
  margin-inline-end: 4px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-small .v-avatar--start {
  margin-inline-start: -8px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-avatar--end {
  margin-inline-start: 4px;
  margin-inline-end: -5.6px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-small .v-avatar--end {
  margin-inline-end: -8px;
}

:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-small .v-avatar--end + .v-chip__close {
  margin-inline-start: 12px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-icon--start,
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-chip__filter {
  margin-inline-start: -4px;
  margin-inline-end: 4px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-icon--end,
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-chip__close {
  margin-inline-start: 4px;
  margin-inline-end: -4px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-icon--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-avatar--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-x-small .v-chip__append + .v-chip__close {
  margin-inline-start: 8px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-small {
  --v-chip-size: 0.75rem;
  --v-chip-height: 26px;
  font-size: 0.75rem;
  padding: 0 10px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-avatar {
  --v-avatar-height: 20px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-small .v-avatar {
  --v-avatar-height: 26px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-small .v-avatar--start {
  margin-inline-start: -7px;
  margin-inline-end: 5px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-small .v-avatar--start {
  margin-inline-start: -10px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-small .v-avatar--end {
  margin-inline-start: 5px;
  margin-inline-end: -7px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-small .v-avatar--end {
  margin-inline-end: -10px;
}

:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-small .v-avatar--end + .v-chip__close {
  margin-inline-start: 15px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-small .v-icon--start,
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-chip__filter {
  margin-inline-start: -5px;
  margin-inline-end: 5px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-icon--end,
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-chip__close {
  margin-inline-start: 5px;
  margin-inline-end: -5px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-icon--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-avatar--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-small .v-chip__append + .v-chip__close {
  margin-inline-start: 10px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-default {
  --v-chip-size: 0.875rem;
  --v-chip-height: 32px;
  font-size: 0.875rem;
  padding: 0 12px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-avatar {
  --v-avatar-height: 26px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-default .v-avatar {
  --v-avatar-height: 32px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-default .v-avatar--start {
  margin-inline-start: -8.4px;
  margin-inline-end: 6px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-default .v-avatar--start {
  margin-inline-start: -12px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-default .v-avatar--end {
  margin-inline-start: 6px;
  margin-inline-end: -8.4px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-default .v-avatar--end {
  margin-inline-end: -12px;
}

:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-default .v-avatar--end + .v-chip__close {
  margin-inline-start: 18px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-default .v-icon--start,
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-chip__filter {
  margin-inline-start: -6px;
  margin-inline-end: 6px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-icon--end,
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-chip__close {
  margin-inline-start: 6px;
  margin-inline-end: -6px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-icon--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-avatar--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-default .v-chip__append + .v-chip__close {
  margin-inline-start: 12px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-large {
  --v-chip-size: 1rem;
  --v-chip-height: 38px;
  font-size: 1rem;
  padding: 0 14px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-avatar {
  --v-avatar-height: 32px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-large .v-avatar {
  --v-avatar-height: 38px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-large .v-avatar--start {
  margin-inline-start: -9.8px;
  margin-inline-end: 7px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-large .v-avatar--start {
  margin-inline-start: -14px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-large .v-avatar--end {
  margin-inline-start: 7px;
  margin-inline-end: -9.8px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-large .v-avatar--end {
  margin-inline-end: -14px;
}

:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-large .v-avatar--end + .v-chip__close {
  margin-inline-start: 21px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-large .v-icon--start,
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-chip__filter {
  margin-inline-start: -7px;
  margin-inline-end: 7px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-icon--end,
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-chip__close {
  margin-inline-start: 7px;
  margin-inline-end: -7px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-icon--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-avatar--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-large .v-chip__append + .v-chip__close {
  margin-inline-start: 14px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-large {
  --v-chip-size: 1.125rem;
  --v-chip-height: 44px;
  font-size: 1.125rem;
  padding: 0 17px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-avatar {
  --v-avatar-height: 38px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-large .v-avatar {
  --v-avatar-height: 44px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-avatar--start {
  margin-inline-start: -11.9px;
  margin-inline-end: 8.5px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-large .v-avatar--start {
  margin-inline-start: -17px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-avatar--end {
  margin-inline-start: 8.5px;
  margin-inline-end: -11.9px;
}
:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-large .v-avatar--end {
  margin-inline-end: -17px;
}

:where(.vuetify-styles) .v-chip--pill.v-chip.v-chip--size-x-large .v-avatar--end + .v-chip__close {
  margin-inline-start: 25.5px;
}

:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-icon--start,
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-chip__filter {
  margin-inline-start: -8.5px;
  margin-inline-end: 8.5px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-icon--end,
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-chip__close {
  margin-inline-start: 8.5px;
  margin-inline-end: -8.5px;
}
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-icon--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-avatar--end + .v-chip__close,
:where(.vuetify-styles) .v-chip.v-chip--size-x-large .v-chip__append + .v-chip__close {
  margin-inline-start: 17px;
}

:where(.vuetify-styles) .v-chip.v-chip--density-default {
  height: calc(var(--v-chip-height) + 0px);
}

:where(.vuetify-styles) .v-chip.v-chip--density-comfortable {
  height: calc(var(--v-chip-height) + -4px);
}

:where(.vuetify-styles) .v-chip.v-chip--density-compact {
  height: calc(var(--v-chip-height) + -8px);
}

:where(.vuetify-styles) .v-chip {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-chip:hover > .v-chip__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-chip:focus-visible > .v-chip__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-chip:focus > .v-chip__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-chip--active > .v-chip__overlay, :where(.vuetify-styles) .v-chip[aria-haspopup=menu][aria-expanded=true] > .v-chip__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-chip--active:hover > .v-chip__overlay, :where(.vuetify-styles) .v-chip[aria-haspopup=menu][aria-expanded=true]:hover > .v-chip__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-chip--active:focus-visible > .v-chip__overlay, :where(.vuetify-styles) .v-chip[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-chip__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-chip--active:focus > .v-chip__overlay, :where(.vuetify-styles) .v-chip[aria-haspopup=menu][aria-expanded=true]:focus > .v-chip__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-chip {
  border-radius: 9999px;
}
:where(.vuetify-styles) .v-chip--variant-plain, :where(.vuetify-styles) .v-chip--variant-outlined, :where(.vuetify-styles) .v-chip--variant-text, :where(.vuetify-styles) .v-chip--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-chip--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-chip--variant-plain:focus, :where(.vuetify-styles) .v-chip--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-chip--variant-plain .v-chip__overlay {
  display: none;
}
:where(.vuetify-styles) .v-chip--variant-elevated, :where(.vuetify-styles) .v-chip--variant-flat {
  background: rgb(var(--v-theme-surface-variant));
  color: rgb(var(--v-theme-on-surface-variant));
}
:where(.vuetify-styles) .v-chip--variant-elevated {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-chip--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-chip--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-chip--variant-text .v-chip__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-chip--variant-tonal .v-chip__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-chip .v-chip__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-chip--border {
  border-width: thin;
}
:where(.vuetify-styles) .v-chip--link {
  cursor: pointer;
}
:where(.vuetify-styles) .v-chip--link, :where(.vuetify-styles) .v-chip--filter {
  -webkit-user-select: none;
          user-select: none;
}
:where(.vuetify-styles) .v-chip--label {
  border-radius: 4px;
}

:where(.vuetify-styles) .v-chip__content {
  align-items: center;
  display: inline-flex;
}
:where(.vuetify-styles) .v-autocomplete__selection .v-chip__content, :where(.vuetify-styles) .v-combobox__selection .v-chip__content, :where(.vuetify-styles) .v-select__selection .v-chip__content {
  overflow: hidden;
}

:where(.vuetify-styles) .v-chip__filter,
:where(.vuetify-styles) .v-chip__prepend,
:where(.vuetify-styles) .v-chip__append,
:where(.vuetify-styles) .v-chip__close {
  align-items: center;
  display: inline-flex;
}

:where(.vuetify-styles) .v-chip__close {
  cursor: pointer;
  flex: 0 1 auto;
  font-size: 18px;
  max-height: 18px;
  max-width: 18px;
  -webkit-user-select: none;
          user-select: none;
}
:where(.vuetify-styles) .v-chip__close .v-icon {
  font-size: inherit;
}

:where(.vuetify-styles) .v-chip__filter {
  transition: 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

:where(.vuetify-styles) .v-chip__overlay {
  background-color: currentColor;
  border-radius: inherit;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
:where(.vuetify-styles) .v-chip__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-chip--disabled {
  opacity: 0.3;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

:where(.vuetify-styles) .v-chip--label {
  border-radius: 4px;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-chip:not(.v-chip--variant-text, .v-chip--variant-plain) {
    border: thin solid;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VChip/VChip.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".v-chip {\n  align-items: center;\n  display: inline-flex;\n  font-weight: 400;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.v-chip .v-icon {\n  --v-icon-size-multiplier: 0.8571428571;\n}\n.v-chip.v-chip--size-x-small {\n  --v-chip-size: 0.625rem;\n  --v-chip-height: 20px;\n  font-size: 0.625rem;\n  padding: 0 8px;\n}\n.v-chip.v-chip--size-x-small .v-avatar {\n  --v-avatar-height: 14px;\n}\n.v-chip--pill.v-chip.v-chip--size-x-small .v-avatar {\n  --v-avatar-height: 20px;\n}\n\n.v-chip.v-chip--size-x-small .v-avatar--start {\n  margin-inline-start: -5.6px;\n  margin-inline-end: 4px;\n}\n.v-chip--pill.v-chip.v-chip--size-x-small .v-avatar--start {\n  margin-inline-start: -8px;\n}\n\n.v-chip.v-chip--size-x-small .v-avatar--end {\n  margin-inline-start: 4px;\n  margin-inline-end: -5.6px;\n}\n.v-chip--pill.v-chip.v-chip--size-x-small .v-avatar--end {\n  margin-inline-end: -8px;\n}\n\n.v-chip--pill.v-chip.v-chip--size-x-small .v-avatar--end + .v-chip__close {\n  margin-inline-start: 12px;\n}\n\n.v-chip.v-chip--size-x-small .v-icon--start,\n.v-chip.v-chip--size-x-small .v-chip__filter {\n  margin-inline-start: -4px;\n  margin-inline-end: 4px;\n}\n.v-chip.v-chip--size-x-small .v-icon--end,\n.v-chip.v-chip--size-x-small .v-chip__close {\n  margin-inline-start: 4px;\n  margin-inline-end: -4px;\n}\n.v-chip.v-chip--size-x-small .v-icon--end + .v-chip__close,\n.v-chip.v-chip--size-x-small .v-avatar--end + .v-chip__close,\n.v-chip.v-chip--size-x-small .v-chip__append + .v-chip__close {\n  margin-inline-start: 8px;\n}\n\n.v-chip.v-chip--size-small {\n  --v-chip-size: 0.75rem;\n  --v-chip-height: 26px;\n  font-size: 0.75rem;\n  padding: 0 10px;\n}\n.v-chip.v-chip--size-small .v-avatar {\n  --v-avatar-height: 20px;\n}\n.v-chip--pill.v-chip.v-chip--size-small .v-avatar {\n  --v-avatar-height: 26px;\n}\n\n.v-chip.v-chip--size-small .v-avatar--start {\n  margin-inline-start: -7px;\n  margin-inline-end: 5px;\n}\n.v-chip--pill.v-chip.v-chip--size-small .v-avatar--start {\n  margin-inline-start: -10px;\n}\n\n.v-chip.v-chip--size-small .v-avatar--end {\n  margin-inline-start: 5px;\n  margin-inline-end: -7px;\n}\n.v-chip--pill.v-chip.v-chip--size-small .v-avatar--end {\n  margin-inline-end: -10px;\n}\n\n.v-chip--pill.v-chip.v-chip--size-small .v-avatar--end + .v-chip__close {\n  margin-inline-start: 15px;\n}\n\n.v-chip.v-chip--size-small .v-icon--start,\n.v-chip.v-chip--size-small .v-chip__filter {\n  margin-inline-start: -5px;\n  margin-inline-end: 5px;\n}\n.v-chip.v-chip--size-small .v-icon--end,\n.v-chip.v-chip--size-small .v-chip__close {\n  margin-inline-start: 5px;\n  margin-inline-end: -5px;\n}\n.v-chip.v-chip--size-small .v-icon--end + .v-chip__close,\n.v-chip.v-chip--size-small .v-avatar--end + .v-chip__close,\n.v-chip.v-chip--size-small .v-chip__append + .v-chip__close {\n  margin-inline-start: 10px;\n}\n\n.v-chip.v-chip--size-default {\n  --v-chip-size: 0.875rem;\n  --v-chip-height: 32px;\n  font-size: 0.875rem;\n  padding: 0 12px;\n}\n.v-chip.v-chip--size-default .v-avatar {\n  --v-avatar-height: 26px;\n}\n.v-chip--pill.v-chip.v-chip--size-default .v-avatar {\n  --v-avatar-height: 32px;\n}\n\n.v-chip.v-chip--size-default .v-avatar--start {\n  margin-inline-start: -8.4px;\n  margin-inline-end: 6px;\n}\n.v-chip--pill.v-chip.v-chip--size-default .v-avatar--start {\n  margin-inline-start: -12px;\n}\n\n.v-chip.v-chip--size-default .v-avatar--end {\n  margin-inline-start: 6px;\n  margin-inline-end: -8.4px;\n}\n.v-chip--pill.v-chip.v-chip--size-default .v-avatar--end {\n  margin-inline-end: -12px;\n}\n\n.v-chip--pill.v-chip.v-chip--size-default .v-avatar--end + .v-chip__close {\n  margin-inline-start: 18px;\n}\n\n.v-chip.v-chip--size-default .v-icon--start,\n.v-chip.v-chip--size-default .v-chip__filter {\n  margin-inline-start: -6px;\n  margin-inline-end: 6px;\n}\n.v-chip.v-chip--size-default .v-icon--end,\n.v-chip.v-chip--size-default .v-chip__close {\n  margin-inline-start: 6px;\n  margin-inline-end: -6px;\n}\n.v-chip.v-chip--size-default .v-icon--end + .v-chip__close,\n.v-chip.v-chip--size-default .v-avatar--end + .v-chip__close,\n.v-chip.v-chip--size-default .v-chip__append + .v-chip__close {\n  margin-inline-start: 12px;\n}\n\n.v-chip.v-chip--size-large {\n  --v-chip-size: 1rem;\n  --v-chip-height: 38px;\n  font-size: 1rem;\n  padding: 0 14px;\n}\n.v-chip.v-chip--size-large .v-avatar {\n  --v-avatar-height: 32px;\n}\n.v-chip--pill.v-chip.v-chip--size-large .v-avatar {\n  --v-avatar-height: 38px;\n}\n\n.v-chip.v-chip--size-large .v-avatar--start {\n  margin-inline-start: -9.8px;\n  margin-inline-end: 7px;\n}\n.v-chip--pill.v-chip.v-chip--size-large .v-avatar--start {\n  margin-inline-start: -14px;\n}\n\n.v-chip.v-chip--size-large .v-avatar--end {\n  margin-inline-start: 7px;\n  margin-inline-end: -9.8px;\n}\n.v-chip--pill.v-chip.v-chip--size-large .v-avatar--end {\n  margin-inline-end: -14px;\n}\n\n.v-chip--pill.v-chip.v-chip--size-large .v-avatar--end + .v-chip__close {\n  margin-inline-start: 21px;\n}\n\n.v-chip.v-chip--size-large .v-icon--start,\n.v-chip.v-chip--size-large .v-chip__filter {\n  margin-inline-start: -7px;\n  margin-inline-end: 7px;\n}\n.v-chip.v-chip--size-large .v-icon--end,\n.v-chip.v-chip--size-large .v-chip__close {\n  margin-inline-start: 7px;\n  margin-inline-end: -7px;\n}\n.v-chip.v-chip--size-large .v-icon--end + .v-chip__close,\n.v-chip.v-chip--size-large .v-avatar--end + .v-chip__close,\n.v-chip.v-chip--size-large .v-chip__append + .v-chip__close {\n  margin-inline-start: 14px;\n}\n\n.v-chip.v-chip--size-x-large {\n  --v-chip-size: 1.125rem;\n  --v-chip-height: 44px;\n  font-size: 1.125rem;\n  padding: 0 17px;\n}\n.v-chip.v-chip--size-x-large .v-avatar {\n  --v-avatar-height: 38px;\n}\n.v-chip--pill.v-chip.v-chip--size-x-large .v-avatar {\n  --v-avatar-height: 44px;\n}\n\n.v-chip.v-chip--size-x-large .v-avatar--start {\n  margin-inline-start: -11.9px;\n  margin-inline-end: 8.5px;\n}\n.v-chip--pill.v-chip.v-chip--size-x-large .v-avatar--start {\n  margin-inline-start: -17px;\n}\n\n.v-chip.v-chip--size-x-large .v-avatar--end {\n  margin-inline-start: 8.5px;\n  margin-inline-end: -11.9px;\n}\n.v-chip--pill.v-chip.v-chip--size-x-large .v-avatar--end {\n  margin-inline-end: -17px;\n}\n\n.v-chip--pill.v-chip.v-chip--size-x-large .v-avatar--end + .v-chip__close {\n  margin-inline-start: 25.5px;\n}\n\n.v-chip.v-chip--size-x-large .v-icon--start,\n.v-chip.v-chip--size-x-large .v-chip__filter {\n  margin-inline-start: -8.5px;\n  margin-inline-end: 8.5px;\n}\n.v-chip.v-chip--size-x-large .v-icon--end,\n.v-chip.v-chip--size-x-large .v-chip__close {\n  margin-inline-start: 8.5px;\n  margin-inline-end: -8.5px;\n}\n.v-chip.v-chip--size-x-large .v-icon--end + .v-chip__close,\n.v-chip.v-chip--size-x-large .v-avatar--end + .v-chip__close,\n.v-chip.v-chip--size-x-large .v-chip__append + .v-chip__close {\n  margin-inline-start: 17px;\n}\n\n.v-chip.v-chip--density-default {\n  height: calc(var(--v-chip-height) + 0px);\n}\n\n.v-chip.v-chip--density-comfortable {\n  height: calc(var(--v-chip-height) + -4px);\n}\n\n.v-chip.v-chip--density-compact {\n  height: calc(var(--v-chip-height) + -8px);\n}\n\n.v-chip {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-chip:hover > .v-chip__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-chip:focus-visible > .v-chip__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-chip:focus > .v-chip__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-chip--active > .v-chip__overlay, .v-chip[aria-haspopup=menu][aria-expanded=true] > .v-chip__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-chip--active:hover > .v-chip__overlay, .v-chip[aria-haspopup=menu][aria-expanded=true]:hover > .v-chip__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-chip--active:focus-visible > .v-chip__overlay, .v-chip[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-chip__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-chip--active:focus > .v-chip__overlay, .v-chip[aria-haspopup=menu][aria-expanded=true]:focus > .v-chip__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-chip {\n  border-radius: 9999px;\n}\n.v-chip--variant-plain, .v-chip--variant-outlined, .v-chip--variant-text, .v-chip--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-chip--variant-plain {\n  opacity: 0.62;\n}\n.v-chip--variant-plain:focus, .v-chip--variant-plain:hover {\n  opacity: 1;\n}\n.v-chip--variant-plain .v-chip__overlay {\n  display: none;\n}\n.v-chip--variant-elevated, .v-chip--variant-flat {\n  background: rgb(var(--v-theme-surface-variant));\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n.v-chip--variant-elevated {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-chip--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-chip--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-chip--variant-text .v-chip__overlay {\n  background: currentColor;\n}\n.v-chip--variant-tonal .v-chip__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-chip .v-chip__underlay {\n  position: absolute;\n}\n.v-chip--border {\n  border-width: thin;\n}\n.v-chip--link {\n  cursor: pointer;\n}\n.v-chip--link, .v-chip--filter {\n  user-select: none;\n}\n.v-chip--label {\n  border-radius: 4px;\n}\n\n.v-chip__content {\n  align-items: center;\n  display: inline-flex;\n}\n.v-autocomplete__selection .v-chip__content, .v-combobox__selection .v-chip__content, .v-select__selection .v-chip__content {\n  overflow: hidden;\n}\n\n.v-chip__filter,\n.v-chip__prepend,\n.v-chip__append,\n.v-chip__close {\n  align-items: center;\n  display: inline-flex;\n}\n\n.v-chip__close {\n  cursor: pointer;\n  flex: 0 1 auto;\n  font-size: 18px;\n  max-height: 18px;\n  max-width: 18px;\n  user-select: none;\n}\n.v-chip__close .v-icon {\n  font-size: inherit;\n}\n\n.v-chip__filter {\n  transition: 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.v-chip__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n.v-chip__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.v-chip--disabled {\n  opacity: 0.3;\n  pointer-events: none;\n  user-select: none;\n}\n\n.v-chip--label {\n  border-radius: 4px;\n}\n\n@media (forced-colors: active) {\n  .v-chip:not(.v-chip--variant-text, .v-chip--variant-plain) {\n    border: thin solid;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
